export default "__VITE_ASSET__PrhvWLmY__"